import React from "react";

export default function AboutUs() {
    return (
        <div style={{ backgroundColor: "#f8fbff" }}>

            {/* HERO SECTION */}
            <section className="py-5" style={{ background: "linear-gradient(135deg, #1e88e5, #42a5f5)" }}>
                <div className="container py-5 text-white">
                    <div className="row align-items-center">
                        <div className="col-lg-7">
                            <h1 className="fw-bold display-4 mb-3">
                                About <span className="fw-bolder">DialNepal</span>
                            </h1>
                            <p className="lead">
                                Nepal’s fastest-growing digital local search engine helping
                                millions discover trusted businesses and services within seconds.
                            </p>
                        </div>

                        <div className="col-lg-5 text-center">
                            <img
                                src="https://img.freepik.com/free-vector/online-search-concept-illustration_114360-4195.jpg"
                                className="img-fluid rounded shadow-lg"
                                style={{ maxHeight: "280px" }}
                                alt="DialNepal Search"
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* ABOUT BLOCK */}
            <section className="container py-5">
                <div className="bg-white rounded-4 shadow-sm p-4 p-lg-5 border">
                    <h2 className="fw-bold text-dark mb-4">Who We Are</h2>

                    <p className="text-muted fs-6 lh-lg">
                        <strong className="text-primary">DialNepal</strong> is Nepal’s most trusted
                        local search and discovery platform, designed to help people find businesses,
                        services, and professionals effortlessly. Our goal is to bridge the gap between
                        customers and service providers through verified information, a smooth search
                        experience, and modern digital tools.
                    </p>

                    <p className="text-muted fs-6 lh-lg">
                        We aim to empower local businesses by giving them a strong online presence and
                        enabling them to connect with the right audience. Whether it’s a small shop, a
                        startup, or a large enterprise—DialNepal helps showcase your services to millions
                        of potential customers across the country.
                    </p>

                    <p className="text-muted fs-6 lh-lg">
                        On the user side, we focus on accuracy, reliability, and convenience. Users can
                        explore thousands of categories such as healthcare, hospitality, education,
                        home services, transportation, IT services, emergency resources, and much more—
                        all at their fingertips.
                    </p>

                    <p className="text-muted fs-6 lh-lg">
                        At DialNepal, we believe that technology should make daily life easier.
                        That’s why we constantly upgrade our platform with better search features,
                        verified listings, user reviews, business profiles, and smart recommendations.
                        Our mission is to become the digital gateway for Nepal’s local businesses and
                        a one-stop destination for all service needs.
                    </p>

                    <p className="text-muted fs-6 lh-lg">
                        With a vision to digitally transform Nepal’s business ecosystem, we are committed
                        to building a platform that supports growth, transparency, and trust—making
                        everyday searches simpler, smarter, and faster for every Nepali.
                    </p>
                </div>

            </section>

            {/* STATS */}
            <section className="py-5">
                <div className="container">
                    <div className="row g-4 text-center">
                        {[
                            { num: "50,000+", label: "Verified Listings" },
                            { num: "120+", label: "Business Categories" },
                            { num: "1M+", label: "Monthly Searches" },
                            { num: "24/7", label: "Instant Access" },
                        ].map((stat, i) => (
                            <div key={i} className="col-6 col-lg-3">
                                <div className="bg-white rounded-4 shadow p-4">
                                    <h2 className="fw-bold text-primary">{stat.num}</h2>
                                    <p className="text-muted mb-0 fw-semibold">{stat.label}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* OUR MISSION & VISION */}
            <section className="container py-5">
                <div className="row g-4">
                    <div className="col-lg-6">
                        <div className="p-4 rounded-4 shadow bg-white h-100 border-start border-primary border-4">
                            <h4 className="fw-bold text-dark">Our Mission</h4>
                            <p className="text-muted mt-2">
                                To build Nepal’s largest and most reliable platform that helps
                                people connect with businesses instantly with accuracy, trust, and
                                transparency.
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="p-4 rounded-4 shadow bg-white h-100 border-start border-primary border-4">
                            <h4 className="fw-bold text-dark">Our Vision</h4>
                            <p className="text-muted mt-2">
                                To transform Nepal’s local business ecosystem through digital
                                innovation — empowering users with information and businesses with
                                visibility.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* FEATURES */}
            <section className="py-5" style={{ backgroundColor: "#eef6ff" }}>
                <div className="container">
                    <h2 className="fw-bold text-dark text-center mb-4">What We Offer</h2>

                    <div className="row g-4">
                        {[
                            "Verified Business Listings",
                            "Fast Keyword & Location Search",
                            "Photos, Reviews & Ratings",
                            "Business Contact Details",
                            "Smart Categories",
                            "Maps & Directions",
                            "Secure & Trusted Platform",
                            "Business Growth Tools",
                        ].map((f, i) => (
                            <div key={i} className="col-6 col-lg-3">
                                <div className="bg-white p-4 rounded-4 shadow-sm text-center h-100">
                                    <i className="bi bi-check-circle-fill text-primary fs-2 mb-2"></i>
                                    <p className="fw-semibold mb-0">{f}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* WHY CHOOSE US */}
            <section className="container py-5">
                <div className="bg-primary text-white p-4 p-lg-5 rounded-4 shadow">
                    <h2 className="fw-bold mb-3">Why Choose DialNepal?</h2>
                    <ul className="fs-6">
                        <li className="mb-2">✔ Accurate & Verified Local Data</li>
                        <li className="mb-2">✔ Clean, Fast, and Modern UI</li>
                        <li className="mb-2">✔ Designed especially for Nepali users</li>
                        <li className="mb-2">✔ 100% Free for Users</li>
                        <li className="mb-2">✔ Business Growth Through Listings</li>
                    </ul>
                </div>
            </section>

            {/* CTA */}
            <section className="text-center py-5">
                <h2 className="fw-bold text-dark mb-2">List Your Business on DialNepal</h2>
                <p className="text-muted mb-4">Reach thousands of customers instantly.</p>
                <button className="btn btn-primary btn-lg rounded-3 px-4">
                    Add Your Listing
                </button>
            </section>
        </div>
    );
}
